import * as React from "react";
import { InputPrimitive } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface UnitInputProps extends React.ComponentPropsWithoutRef<typeof InputPrimitive> {
  unit: React.ReactNode;
}

/** Compact numeric/text input with a non-editable trailing unit. */
export const UnitInput = React.forwardRef<HTMLInputElement, UnitInputProps>(function UnitInput(
  { className, unit, ...props },
  ref,
): React.ReactElement {
  return (
    <span
      className={cn(
        "inline-flex h-[34px] w-full items-center rounded-[8px] border border-control-border bg-control-default px-2.5 text-ink ring-ring/15 transition-[border-color,box-shadow,background-color] hover:border-control-border-hover hover:bg-control-highlight focus-within:border-ring focus-within:bg-control-default focus-within:ring-2 has-[input[aria-invalid=true]]:border-destructive has-[input[aria-invalid=true]]:ring-2 has-[input[aria-invalid=true]]:ring-destructive/15",
        className,
      )}
      data-slot="unit-input"
    >
      <InputPrimitive
        ref={ref}
        className="h-full min-w-0 flex-1 bg-transparent text-[12px] font-semibold leading-4 tabular-nums outline-none placeholder:text-muted-foreground"
        {...props}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none shrink-0 text-[12px] font-medium leading-4 text-muted-foreground"
      >
        {unit}
      </span>
    </span>
  );
});
